import { useGetAffiliateUserStatusQuery } from '../../store/api/affiliateApi';

/** Every affiliate sees these two, and they show while the status loads. */
const MARKETING = '/affiliate/marketing';
// Hidden for now, with the Dashboard page.
// const DASHBOARD = '/affiliate';
/** The partner-programme pages a retainer-only affiliate doesn't get. */
const PROGRAMME = ['/affiliate/giveaway', '/affiliate/winner-submission', '/affiliate/personal-account'];
const RETAINER = '/affiliate/retainer';

/**
 * What the trader may see and do in Affiliate, from `/affiliate/user/status/`
 * (`is_super_affiliate`, `is_retainer`):
 *
 *   super affiliate only   every page except Retainer        may apply
 *   retainer only          Dashboard, Retainer, Marketing     may not apply
 *   both                   every page                         may apply
 *   neither                Dashboard, Marketing               may apply
 *
 * If the status can't be read, only Dashboard and Affiliate Marketing show —
 * the rest opens once the call answers.
 */
export default function useAffiliateAccess() {
  const { data, isSuccess, isError } = useGetAffiliateUserStatusQuery();

  const isSuper = Boolean(data?.is_super_affiliate);
  const isRetainer = Boolean(data?.is_retainer);

  // Only Affiliate Marketing for now — the Dashboard is hidden with its route.
  // const allowed = new Set([DASHBOARD, MARKETING]);
  const allowed = new Set([MARKETING]);
  if (isSuccess && (isSuper || isRetainer)) {
    if (isSuper) PROGRAMME.forEach((to) => allowed.add(to));
    if (isRetainer) allowed.add(RETAINER);
  }

  return {
    /** Whether the answer is in — no redirects before it. */
    ready: isSuccess || isError,
    canSee: (to) => allowed.has(to),
    /** Where the section opens. Always Affiliate Marketing for now — the Dashboard is hidden. */
    // home: DASHBOARD,
    home: MARKETING,
  };
}
